import { MapStore } from './stores/map-store';
import { LocalStorageAdapter } from './stores/adapters/storage-adapter';

const store = new MapStore(new LocalStorageAdapter());
const getItem = (name: string): unknown => {
    return store.get(name);
};
const hasItem = (name: string): boolean => {
    return store.has(name);
};
const getItems = () => {
    return store.getAll();
};
const deleteItem = (name: string): void => {
    store.delete(name);
};
const setItem = (name: string, value: unknown) => {
    store.set(name, value);
};
export { getItem, getItems, setItem, hasItem, deleteItem };
